export default {_name:'badge',module:'Card/Pane',view:'Element/Badge',options:{events:{onChange:'persistUnsaveChange'}}}